import './TransitionModal.scss';
import { useScreenSize } from '@custom/dx3';
import { Dialog } from '@mui/material';
import type { SlideProps } from '@mui/material/Slide';
import Slide from '@mui/material/Slide';
import classNames from 'classnames';
import { type PropsWithChildren, forwardRef } from 'react';

const SlideUp = forwardRef(function SlideUp(props: SlideProps, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function TransitionModal({
  children,
  mobilePaperClassName,
  open,
  onClose,
  paperClassName,
}: PropsWithChildren<{
  mobilePaperClassName?: string;
  open: boolean;
  onClose: () => void;
  paperClassName?: string;
}>): JSX.Element {
  const isMobile = useScreenSize() === 'mobile';

  return (
    <Dialog
      aria-labelledby="dialog-title"
      fullScreen={isMobile}
      open={open}
      onClose={onClose}
      PaperProps={{
        className: classNames(paperClassName, isMobile && mobilePaperClassName),
      }}
      TransitionComponent={SlideUp}
      role="dialog"
      scroll="body"
    >
      {children}
    </Dialog>
  );
}
